_ = require('lodash')

module.exports = class ScheduleBreaks
  constructor: (stylistRespose) ->
    'ngInject'

    @stylist = stylistRespose.data

